module.exports = __webpack_public_path__ + "static/media/platform-tennis.d8f83595.jpg";